import { ErrorHandler, Injectable, NgZone, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NotifyService } from './notify.service';
import { AuthService } from './auth.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class CustomErrorHandlerService implements ErrorHandler {
  router = inject(Router);
  notify = inject(NotifyService);
  ngZone = inject(NgZone);
  auth = inject(AuthService);
  spinner = inject(NgxSpinnerService);
  handleError(error: any): void {
    // this.spinner.hide();
   // console.log(error)
    this.ngZone.run(() => {
      if (error.status === 401 ) {
        this.spinner.hide();
        this.auth.LogOut();
        this.router.navigateByUrl('/login');
      }
      if (error.status === 400) {
  
        this.spinner.hide();
        if( error.error.title){
        
          this.notify.Notify('Validation Error', error.error.title, 'DANGER');
        }else{
          this.notify.Notify('Validation Error', error.error, 'DANGER');
        }
        
      }
      if (error.status === 500) {
        this.spinner.hide();
        this.notify.Notify("Error", 'Please  wait , we are experiening error', 'DANGER');
      }
      if (error.status === 404) {
        this.spinner.hide();
      }
    });
  }
}
